import { http } from "@/lib/http";
import type { SaleWithRelations } from "@/types/sale-with-relations";
import { useQuery } from "@tanstack/react-query";
import type { FlavorWithIngredients } from "@/lib/sale";

/** A campanha ativa (no máximo uma). 404 significa "nenhuma campanha": vira `null`. */
export function useActiveSale() {
  return useQuery({
    queryKey: ["sale", "me"],
    queryFn: async () => {
      try {
        const { data } = await http.get<SaleWithRelations>("sales/active");
        return data;
      } catch (e) {
        if ((e as { status?: number }).status === 404) return null;
        throw e;
      }
    },
  });
}

export function useFlavors() {
  return useQuery({
    queryKey: ["flavors"],
    queryFn: async () => {
      const { data } = await http.get<FlavorWithIngredients[]>("flavors", {
        params: { all: true },
      });
      return data;
    },
  });
}
